const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHtml5Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1024px",
    height: "1024px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#e34f26",
    d: "M 59.5,-0.5 C 360.167,-0.5 660.833,-0.5 961.5,-0.5C 934.665,306.189 907.498,612.856 880,919.5C 757.722,954.108 635.555,988.775 513.5,1023.5C 510.833,1023.5 508.167,1023.5 505.5,1023.5C 384.112,988.775 262.612,954.108 141,919.5C 113.502,612.855 86.3352,306.188 59.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef652a",
    d: "M 511.5,827.5 C 587.645,805.954 663.979,784.62 740.5,763.5C 742.389,754.957 743.555,746.291 744,737.5C 752.651,630.043 762.485,522.709 773.5,415.5C 686.167,415.5 598.833,415.5 511.5,415.5C 511.5,376.833 511.5,338.167 511.5,299.5C 602.167,299.5 692.833,299.5 783.5,299.5C 787.489,262.229 790.823,224.896 793.5,187.5C 699.5,187.5 605.5,187.5 511.5,187.5C 511.5,149.5 511.5,111.5 511.5,73.5C 634.167,73.5 756.833,73.5 879.5,73.5C 856.313,336.222 832.646,598.889 808.5,861.5C 709.566,888.607 610.733,915.941 512,943.5C 511.5,904.835 511.333,866.168 511.5,827.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebeaea",
    d: "M 509.5,187.5 C 509.5,224.833 509.5,262.167 509.5,299.5C 456.833,299.5 404.167,299.5 351.5,299.5C 355.023,338.148 358.356,376.815 361.5,415.5C 410.833,415.5 460.167,415.5 509.5,415.5C 509.5,453.5 509.5,491.5 509.5,529.5C 425.5,529.5 341.5,529.5 257.5,529.5C 247.078,415.526 237.078,301.526 227.5,187.5C 321.5,187.5 415.5,187.5 509.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fffefe",
    d: "M 509.5,187.5 C 510.167,187.5 510.833,187.5 511.5,187.5C 605.5,187.5 699.5,187.5 793.5,187.5C 790.823,224.896 787.489,262.229 783.5,299.5C 692.833,299.5 602.167,299.5 511.5,299.5C 510.833,299.5 510.167,299.5 509.5,299.5C 509.5,262.167 509.5,224.833 509.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e34f26",
    d: "M 509.5,299.5 C 510.167,299.5 510.833,299.5 511.5,299.5C 511.5,338.167 511.5,376.833 511.5,415.5C 510.833,415.5 510.167,415.5 509.5,415.5C 460.167,415.5 410.833,415.5 361.5,415.5C 358.356,376.815 355.023,338.148 351.5,299.5C 404.167,299.5 456.833,299.5 509.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fffefe",
    d: "M 509.5,415.5 C 510.167,415.5 510.833,415.5 511.5,415.5C 598.833,415.5 686.167,415.5 773.5,415.5C 762.485,522.709 752.651,630.043 744,737.5C 743.555,746.291 742.389,754.957 740.5,763.5C 663.979,784.62 587.645,805.954 511.5,827.5C 510.833,827.5 510.167,827.5 509.5,827.5C 509.5,788.167 509.5,748.833 509.5,709.5C 510.492,709.672 511.158,709.338 511.5,708.5C 552.832,697.5 594.165,686.5 635.5,675.5C 639.978,626.814 644.644,578.147 649.5,529.5C 603.5,529.5 557.5,529.5 511.5,529.5C 510.833,529.5 510.167,529.5 509.5,529.5C 509.5,491.5 509.5,453.5 509.5,415.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef652a",
    d: "M 511.5,529.5 C 557.5,529.5 603.5,529.5 649.5,529.5C 644.644,578.147 639.978,626.814 635.5,675.5C 594.165,686.5 552.832,697.5 511.5,708.5C 511.5,648.833 511.5,589.167 511.5,529.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebeaea",
    d: "M 509.5,709.5 C 509.5,748.833 509.5,788.167 509.5,827.5C 432.525,806.352 355.525,785.186 278.5,764C 273.082,704.583 268.082,645.083 263.5,585.5C 300.833,585.5 338.167,585.5 375.5,585.5C 378.082,615.753 381.082,645.919 384.5,676C 426.156,687.275 467.823,698.442 509.5,709.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5Svg);
export default __webpack_public_path__ + "static/media/HTML5.svg.e2c2ddbf54b175853ba62fe8f31abc4f.svg";
export { ForwardRef as ReactComponent };